let currentPageId: string | undefined;

/**
 * Load the Orange configuration for a given page.
 *
 * This function makes sure we call the `loadConfig` method from the Orange
 * only once for each orange page id.
 */
export async function loadOrangeConfig(orangePageId: string) {
	if (currentPageId === orangePageId && window.adgw_data) {
		return;
	}

	currentPageId = orangePageId;
	await window.ADGW?.loadConfig(`via_${orangePageId}`);
}
